import React, { useState } from "react";
import BannerCritical from "./BannerCritical";
import Drawer2 from "../Drawer2";

const MakePayment = () => {
  return (
    <div className="px-4" style={{ maxWidth: 400 }}>
      <div className="text-center font-bold text-xl mb-4">
        Please make a payment
      </div>
      <div className="flex mt-8 mb-3 justify-center">
        <p className="font-semibold mr-1">Amount Due: </p>
      </div>
      <div className="flex mt-4 items-center flex-col">
        <div>
          <button type="button" className="btn btn-green px-10">
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
};

const ShowPayments = () => {
  return (
    <div>
      <div className="flex mt-6 justify-center">activation banner</div>
    </div>
  );
};

const Banner = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const onSubmit = (exit) => {
    // exit();
    setDrawerOpen(true);
  };

  return (
    <BannerCritical
      title="Your card is currently locked"
      hasModal={false}
      color="#FFCC67"
      ContentComponent={({ exit }) => (
        <ShowPayments
          hasModal={false}
          exit={exit}
          onSubmit={() => onSubmit(exit)}
        />
      )}
    />
  );
};

const ActivationBanner = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onSubmit = (exit) => {
    exit();
    setDrawerOpen(true);
  };

  return (
    <>
      {/* <Banner onSubmit={onSubmit} />
      <Drawer2 isOpen={drawerOpen} close={() => setDrawerOpen(false)}>

      </Drawer2> */}
    </>
  );
};

export default ActivationBanner;
